import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IApplicationInfo} from '../../models/application-info/application-info';
import {shareReplay} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class ApplicationInfoService {
    private readonly httpClient = inject(HttpClient);

    public getInfo(): Observable<IApplicationInfo> {
        return this.httpClient.get<IApplicationInfo>(`${environment.apiUrl}/info`).pipe(shareReplay(1));
    }
}
